import {
    LaneFeesSpreadsheetRow,
} from 'app/Apps/Pricing/LaneFees/LaneFees.types'
import {
    CollectionServiceType,
    DeliveryServiceType,
    LeaseType,
    OrderTemperatureRange, RangeType,
} from 'app/enums/label.enums'
import {
    DomainUIOnly,
    FieldConfig, OnChangeCellFunction, SkyNetSpreadSheetCellType,
    SkyNetSpreadSheetConfigType, TypeaheadParams,
} from 'app/shared-components/SkyNetSpreadSheet'

export default ({
    addRowMenuOption = false,
    getAllowedValues,
    getLabel,
    laneGroupParams,
    onLaneGroupChangeOverride,
}: {
    addRowMenuOption?: boolean,
    getAllowedValues: (value: Record<string, string>) => Record<string, string>,
    getLabel: (label: string) => string,
    laneGroupParams: TypeaheadParams,
    onLaneGroupChangeOverride: OnChangeCellFunction,
}): SkyNetSpreadSheetConfigType<keyof LaneFeesSpreadsheetRow> => {
    const fields: FieldConfig<keyof LaneFeesSpreadsheetRow>[] = [
        {
            name: 'laneGroup',
            title: getLabel('LaneFeesView.lgNumber'),
            required: true,
            ...laneGroupParams,
            domain: DomainUIOnly.LANE_GROUP,
            width: 110,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.TYPEAHEAD,
                onChangeOverride: onLaneGroupChangeOverride,
            },
        },
        {
            name: 'tempRange',
            title: getLabel('AccountLane.temperatureRange'),
            width: 120,
            allowedValues: getAllowedValues(OrderTemperatureRange),
            disabled: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
        },
        {
            name: 'leaseType',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            width: 120,
            allowedValues: getAllowedValues(LeaseType),
            title: getLabel('AccountLane.leaseType'),
            disabled: true,
        },
        {
            name: 'originAirportsIataCode',
            title: getLabel('AccountLane.originAirport'),
            width: 120,
            disabled: true,
        },
        {
            name: 'destinationAirportsIataCode',
            title: getLabel('AccountLane.destinationAirport'),
            width: 120,
            disabled: true,
        },
        {
            name: 'deliveryServiceType',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            allowedValues: getAllowedValues(DeliveryServiceType),
            title: getLabel('AccountLane.deliveryServiceType'),
            width: 150,
            disabled: true,
        },
        {
            name: 'handoverPointLocationName',
            title: getLabel('AccountLane.handoverPoint'),
            width: 200,
            disabled: true,
        },
        {
            name: 'collectionServiceType',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            allowedValues: getAllowedValues(CollectionServiceType),
            title: getLabel('AccountLane.collectionServiceType'),
            disabled: true,
            width: 150,
        },
        {
            name: 'collectionDropoffPointLocationName',
            title: getLabel('AccountLane.collectionDropoffPoint'),
            width: 200,
            disabled: true,
        },
        {
            name: 'validFrom',
            title: getLabel('LaneFeesUpdateDto.validFrom'),
            width: 125,
            format: 'DD.MM.YYYY',
            required: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.DATETIME,
            },
        },
        {
            name: 'validTo',
            title: getLabel('LaneFeesUpdateDto.validTo'),
            width: 125,
            format: 'DD.MM.YYYY',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.DATETIME,
            },
        },
        {
            name: 'rentalDays',
            title: getLabel('LaneFeesUpdateDto.rentalDays'),
            width: 70,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
            },
        },
        {
            name: 'logisticsDays',
            title: getLabel('LaneFeesUpdateDto.logisticsDays'),
            width: 70,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
            },
        },
        {
            name: 'isPerformanceQualification',
            title: getLabel('LaneFees.isPQ'),
            width: 60,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.CHECKBOX,
            },
        },
        {
            name: 'expressOrderTimeline',
            title: getLabel('LaneGroupCreateOrDuplicateDto.expressOrderTimeline'),
            required: true,
            width: 100,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
            },
        },
        {
            name: 'expressDaysType',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            allowedValues: getAllowedValues(RangeType),
            title: getLabel('LaneGroupCreateOrDuplicateDto.expressDaysType'),
            required: true,
            width: 150,
        },
        {
            name: 'postponementFeeTimeline',
            title: getLabel('LaneGroupCreateOrDuplicateDto.postponementFeeTimeline'),
            required: true,
            width: 100,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
            },
        },
        {
            name: 'postponementDaysType',
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            allowedValues: getAllowedValues(RangeType),
            title: getLabel('LaneGroupCreateOrDuplicateDto.postponementDaysType'),
            required: true,
            width: 150,
        },
    ]

    return {
        id: 'LaneFeesSpreadsheet',
        headerRow: true,
        rowsCounter: true,
        headerHeight: 60,
        addRowMenuOption,
        enableRangeSelection: true,
        enableRowSelection: true,
        stickyTopRows: 1,
        filterable: false,
        rowsLimit: 25,
        emptyRows: addRowMenuOption ? 10 : 0,
        initialFocusLocation: {
            columnId: 'laneGroupId',
            rowId: 0,
        },
        fields,
    }
}
